<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1102001000012ogcbd.vue
*@ 컴포넌트설명 :[캄보디아] 예금 상품 > 예금 상품 상세(기업정기예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <section class="deposit detail">
    <!--한국어-->
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>기업정기예금</h2>
          </div>
          <div class="description">
            <p>
              목돈을 일정기간동안 예치하여 안정적인 수익을 목적으로 하는 일시예치식 예금
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">USD</span>
                <span class="text">최대 연</span>
              </div>
              <div class="percent">
                3.1%
              </div>
            </div>
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">KHR</span>
                <span class="text">최대 연</span>
              </div>
              <div class="percent">
                3.6%
              </div>
            </div>
          </div>
          <!--// 금리 이율 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>상품유형</dt>
            <dd>정기예금</dd>
            <dt>상품개요</dt>
            <dd>목돈을 일정기간동안 예치하여 안정적인 수익을 목적으로 하는 일시예치식 예금</dd>
            <dt>가입대상</dt>
            <dd>캄보디아내 현지법인</dd>
            <dt>계약기간</dt>
            <dd>1개월, 3개월, 6개월, 12개월</dd>
            <dt>가입통화</dt>
            <dd>USD, KHR</dd>
            <dt>가입금액</dt>
            <dd>신규가입 시 최저 USD 1,000.00 이상</dd>
            <dt>금리 및 이율</dt>
            <dd>통화 : USD / KHR</dd>
          </dl>
          <div class="tbl-top-etc">(연이율, 세전, 단위%)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="2" scope="col">Term Deposit</th>
                <th scope="col" colspan="2">예금이율</th>
              </tr>
              <tr>
                <th scope="col">USD</th>
                <th scope="col">KHR</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1개월</th>
                <td>1.20</td>
                <td>1.70</td>
              </tr>
              <tr>
                <th scope="row">3개월</th>
                <td>2.00</td>
                <td>2.50</td>
              </tr>
              <tr>
                <th scope="row">6개월</th>
                <td>2.75</td>
                <td>3.20</td>
              </tr>
              <tr>
                <th scope="row">12개월</th>
                <td>3.10</td>
                <td>3.60</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· 중도해지이율 : 연 0.50%</p>
            <p>· 만기이후이율 : 없음</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>수수료</strong>
            <p>해당무</p>
          </div>
          <div class="info info-type4">
            <strong>가입방법</strong>
            <p>영업점가입, 인터넷 가입</p>
          </div>
          <div class="info info-type4">
            <strong>가입시 필요서류</strong>
            <p>
              대표자 내점시 : 사업허가증, 법인등기부등본, 사업자등록증, 정관, 주총결의서, 여권 사본 등<br />
              대리인 내점시 : 사업허가증, 법인등기부등본, 사업자등록증, 정관, 주총결의서, 여권 사본, 위임장 및 대리인 실명확인증<br />
              ·위임장에는 신청직원의 인적사항 및 위임내용이 기재되어야 하며, 법인인감날인이 필요합니다.
            </p>
          </div>
        </article>
      </div>
    </template>

    <!-- 영어 -->
    <template v-else-if="lang == $config.LANG_ENG">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>Corporate Term Deposits Account</h2>
          </div>
          <div class="description">
            <p>
              A temporary deposit product for a stable income by depositing savings for a fixed period of time
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">USD</span>
                <span class="text">Maximum</span>
              </div>
              <div class="percent">
                3.1% annually
              </div>
            </div>
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">KHR</span>
                <span class="text">Maximum</span>
              </div>
              <div class="percent">
                3.6% annually
              </div>
            </div>
          </div>
          <!--// 금리 이율 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Types</dt>
            <dd>Term Deposits</dd>
            <dt>About the products</dt>
            <dd>A temporary deposit product for a stable income by depositing savings for a fixed period of time</dd>
            <dt>Eligibilty</dt>
            <dd>Corporation in Cambodia</dd>
            <dt>Contract Terms</dt>
            <dd>1 month, 3 months, 6 months, or 12 months</dd>
            <dt>Available currency</dt>
            <dd>USD, KHR</dd>
            <dt>Deposit amount</dt>
            <dd>To open an account, a minimum USD 1,000.00 deposit amount is required.</dd>
            <dt>Rates</dt>
            <dd>Currency : USD / KHR</dd>
          </dl>
          <div class="tbl-top-etc">(annual interest rate, pretax, unit : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="2" scope="col">Term Deposit</th>
                <th scope="col" colspan="2">Savings interest rate</th>
              </tr>
              <tr>
                <th scope="col">USD</th>
                <th scope="col">KHR</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">1month</th>
                <td>1.20</td>
                <td>1.70</td>
              </tr>
              <tr>
                <th scope="row">3months</th>
                <td>2.00</td>
                <td>2.50</td>
              </tr>
              <tr>
                <th scope="row">6months</th>
                <td>2.75</td>
                <td>3.20</td>
              </tr>
              <tr>
                <th scope="row">12months</th>
                <td>3.10</td>
                <td>3.60</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· Interest rate for an early termination : 0.50% annually</p>
            <p>· Interest rate after the maturity : None</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>Fees</strong>
            <p>N/A</p>
          </div>

          <div class="info info-type4">
            <strong>How to apply</strong>
            <p>Apply at the branch, Apply Online</p>
          </div>
          <div class="info info-type4">
            <strong>Required documents for application</strong>
            <p>
              When a representative visits : business license, certified copy of corporate registration, business registration card, articles of incorporation, written resolution
              of general stockholders meeting, a copy of passport, etc. <br />
              When a surrogate visits : business license, certified copy of corporate registration, business registration certificate, articles of incorporation, written resolution
              of general stockholders meeting, a copy of passport, a letter of attorney and surrogate's ID<br />
              A letter of attorney is required to have a surrogate's personal information and contents of dlegation, and corporate seal
            </p>
          </div>
        </article>
      </div>
    </template>

    <!--한국어-->
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>គណនីសន្សំមានកាលកំណត់សំរាប់ក្រុមហ៊ុន</h2>
          </div>
          <div class="description">
            <p>
              ប្រាក់ច្រើនដែលបានបញ្ចូលក្នុងរយៈពេលមួយដែលបានកំនត់ក្នុងគោលបំនងទទួលបានអត្ថប្រយោជន៍ ក្នុងការបញ្ចូលនេះ។
            </p>
          </div>
          <!-- 금리 이율 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">USD</span>
                <span class="text">ក្នុងមួយឆ្នាំ</span>
              </div>
              <div class="percent">
                3.1% ជាអតិបរមា
              </div>
            </div>
            <div class="item item-row">
              <div class="tit">
                <span class="exchange-unit">KHR</span>
                <span class="text">ក្នុងមួយឆ្នាំ</span>
              </div>
              <div class="percent">
                3.6% ជាអតិបរមា
              </div>
            </div>
          </div>
          <!--// 금리 이율 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>ប្រភេទផលិតផល</dt>
            <dd>បា្រក់បញ្ញើមានពេលកំណត់</dd>
            <dt>មាតិកាផលិតផល</dt>
            <dd>ប្រាក់ច្រើនដែលបានបញ្ចូលក្នុងរយៈពេលមួយដែលបានកំនត់ក្នុងគោលបំនងទទួលបានអត្ថប្រយោជន៍ ក្នុងការបញ្ចូលនេះ។</dd>
            <dt>អតិថិជនគោលដៅ</dt>
            <dd>សហគ្រាស</dd>
            <dt>រយៈពេលកិច្ចសន្យា</dt>
            <dd>១ខែ ៣ខែ ៦ខែ ១២ខែ</dd>
            <dt>ប្រភេទរូបិយប័ណ្ណដែលស្នើសុំ</dt>
            <dd>USD, KHR</dd>
            <dt>ចំនួនទឹកប្រាក់ដែលស្នើសុំ</dt>
            <dd>ចំនួនទឹកប្រាក់ដំបូងតិចបំផុត USD1,000.00</dd>
            <dt>អត្រាការប្រាក់</dt>
            <dd>រូបិយវត្ : USD / KHR</dd>
          </dl>
          <div class="tbl-top-etc">(ការប្រាក់ប្រចាំឆ្នាំ, បង់ពន្ធជាមុន, ខ្នាត : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="col" rowspan="2" scope="col">Term Deposit</th>
                <th scope="col" colspan="2">ការប្រាក់ក្នុងការបញ្ចូលប្រាក់</th>
              </tr>
              <tr>
                <th scope="col">USD</th>
                <th scope="col">KHR</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">១ខែ</th>
                <td>1.20</td>
                <td>1.70</td>
              </tr>
              <tr>
                <th scope="row">៣ខែ</th>
                <td>2.00</td>
                <td>2.50</td>
              </tr>
              <tr>
                <th scope="row">៦ខែ</th>
                <td>2.75</td>
                <td>3.20</td>
              </tr>
              <tr>
                <th scope="row">១២ខែ</th>
                <td>3.10</td>
                <td>3.60</td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· ការប្រាក់នៅពេលលុបចោលការសន្សំប្រាក់នៅពាក់កណ្តាល:ក្នុងមួយឆ្នាំ 0.50%</p>
            <p>· ការប្រាក់បន្ទាប់ពីផុតកំនត់: គ្មាន</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>កំរៃសេវា</strong>
            <p>គ្មាន</p>
          </div>

          <div class="info info-type4">
            <strong>របៀបចុះឈ្មោះ</strong>
            <p>ចុះឈ្មោះនៅសាខា, ចុះឈ្មោះតាមអ៊ីនធឺណិត</p>
          </div>
          <div class="info info-type4">
            <strong>តំរូវការឯកសារចុះឈ្មោះ</strong>
            <p>
              - លិខិតអនុញ្ញាតបើកអាជីវកម្ម<br />
              - អាជ្ញាប័ណ្ណប្រកបអាជីវកម្ម និង ប័ណ្ណប៉ាតង<br />
              ់ - សេចក្ដីសម្រេចរបស់ក្រុមប្រឹក្សាភិបាល<br />
              - ក្ខន្តិកៈក្រុមហ៊ុន<br />
              - អត្ដសញ្ញាណប័ណ្ណ រឺ លិខិតឆ្លងដែនច្បាប់ដើមរបស់អភិបាល និង អ្នកទទួលសិទ្ឋិប្រសិនមាន។
            </p>
          </div>
        </article>
      </div>
    </template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["lang"]),
  },
};
</script>
